"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _PhotosModule = _interopRequireDefault(require("./Photos.module.css"));

var _reactTextfit = require("react-textfit");

var _grommet = require("grommet");

var _reactYoutube = _interopRequireDefault(require("react-youtube"));

var staticImages = _interopRequireWildcard(require("../staticImages"));

var _reactPlayer = _interopRequireDefault(require("react-player"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var theme = {
  carousel: {
    icons: {
      current: "500px"
    }
  }
};

var Photos = /*#__PURE__*/function (_React$Component) {
  _inherits(Photos, _React$Component);

  var _super = _createSuper(Photos);

  function Photos(props) {
    var _this;

    _classCallCheck(this, Photos);

    _this = _super.call(this, props);
    _this.state = {
      photos: [],
      video: "https://www.youtube.com/embed/fBYvHHT8fdE",
      videoID: "fBYvHHT8fdE",
      fullScreen: false,
      fullImage: null
    };
    _this.closeFull = _this.closeFull.bind(_assertThisInitialized(_this));
    _this.setFullScreen = _this.setFullScreen.bind(_assertThisInitialized(_this));
    return _this;
  }
  /*
  logCarouselClick = () => {
      const userID = firebase.auth().currentUser.uid;
      const date = new Date();
      try {
          const club = this.props.info.uuid ?? 'unknown';
          window.ga('send', 'event', 'Club Page Interaction', 'Photos Carousel Click');
          db.collection('logged_events').add({
              'category': 'Club Page Interaction',
              'action': 'Photos Carousel Click',
              'view_mode': 'unknown',
              'time': date,
              'user': userID,
              'club': club,
              'url': window.location.href,
          });
      } catch (e) {
          db.collection("logged_errors").add({
              'action': 'Photos Carousel Click',
              'view_mode': 'unknown',
              'time': date,
              'url': window.location.href,
          });
      }
  }
  */


  _createClass(Photos, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var _loop = function _loop(i) {
        if (_this2.props.info.media[i].type === "photo") {
          _this2.state.photos.push( /*#__PURE__*/_react["default"].createElement("div", {
            id: _PhotosModule["default"].photo_outer
          }, /*#__PURE__*/_react["default"].createElement(_grommet.Image, {
            fit: "cover",
            src: _this2.props.info.media[i].link,
            id: _PhotosModule["default"].image2,
            key: i
          }), /*#__PURE__*/_react["default"].createElement("div", {
            className: _PhotosModule["default"].expandBlur
          }, /*#__PURE__*/_react["default"].createElement("img", {
            src: staticImages.EXPAND,
            id: _PhotosModule["default"].fullScreen,
            onClick: function onClick() {
              return _this2.setFullScreen(_this2.props.info.media[i].link);
            }
          }))));
        } else if (_this2.props.info.media[i].type === "youtube") {
          link = _this2.props.info.media[i].link;

          if (link.includes("watch?v=")) {
            split = link.split('=');
          } else {
            split = link.split('/');
          }

          id = split[split.length - 1];

          _this2.state.photos.push( /*#__PURE__*/_react["default"].createElement("iframe", {
            allow: "fullscreen",
            width: "88%",
            height: "100%",
            style: {
              marginLeft: '6%',
              zIndex: 15,
              borderRadius: '15px',
              borderStyle: 'none'
            },
            src: "https://www.youtube.com/embed/" + id
          }) // <ReactPlayer style = {{zIndex: 20, width: '100%', heigth: '100%'}} id = {styles.video}
          //   url={this.state.video}
          // />                    
          );
        } // else if (this.props.info.media[i].type === "vimeo"){
        //   this.state.photos.push(
        //     <iframe allow = "fullscreen" width="100%" height="100%" style = {{zIndex: 15, borderRadius: '15px', borderStyle: 'none'}}
        //       src={this.props.info.media[i].link}>
        //     </iframe>
        //     // <ReactPlayer style = {{zIndex: 20, width: '100%', heigth: '100%'}} id = {styles.video}
        //     //   url={this.state.video}
        //     // />                    
        //   )
        // }


        if (i + 1 === _this2.props.info.media.length) {
          _this2.forceUpdate();
        }
      };

      for (var i = 0; i < this.props.info.media.length; ++i) {
        var link;
        var split;
        var id;

        _loop(i);
      }
    }
  }, {
    key: "setFullScreen",
    value: function setFullScreen(image) {
      this.setState({
        fullScreen: true,
        fullImage: image
      });
    }
  }, {
    key: "closeFull",
    value: function closeFull() {
      this.setState({
        fullScreen: false,
        fullImage: null
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      if (this.state.fullScreen) {
        var width = 0;

        if (window.innerWidth > 1717) {
          width = 1283;
        } else if (window.innerWidth >= 1601 && window.innerWidth <= 1717) {
          width = window.innerWidth - 434;
        } else if (window.innerWidth >= 1268 && window.innerWidth <= 1600) {
          width = 1166;
        } else {
          width = window.innerWidth - 100;
        }

        return /*#__PURE__*/_react["default"].createElement("div", {
          id: _PhotosModule["default"].outer_div
        }, /*#__PURE__*/_react["default"].createElement(_grommet.Layer, {
          style: {
            background: "none"
          }
        }, /*#__PURE__*/_react["default"].createElement(_grommet.Box, {
          background: "white",
          round: "25px",
          width: "".concat(width, "px"),
          height: "668px"
        }, /*#__PURE__*/_react["default"].createElement(_grommet.Image, {
          fit: "cover",
          src: this.state.fullImage,
          id: _PhotosModule["default"].image2
        }), /*#__PURE__*/_react["default"].createElement("div", {
          className: _PhotosModule["default"].expandBlur
        }, /*#__PURE__*/_react["default"].createElement("img", {
          src: staticImages.CLOSE,
          alt: "close",
          id: _PhotosModule["default"].close,
          onClick: function onClick() {
            return _this3.closeFull();
          }
        })))));
      } else {
        return /*#__PURE__*/_react["default"].createElement("div", {
          id: _PhotosModule["default"].outer_div
        }, /*#__PURE__*/_react["default"].createElement("div", {
          id: _PhotosModule["default"].description
        }, /*#__PURE__*/_react["default"].createElement(_reactTextfit.Textfit, {
          max: 17,
          mode: "multi",
          className: _PhotosModule["default"].content,
          style: {
            height: "100%"
          }
        }, this.props.info.medium_description)), /*#__PURE__*/_react["default"].createElement(_grommet.Box, {
          id: _PhotosModule["default"].image
        }, /*#__PURE__*/_react["default"].createElement(_grommet.Carousel, {
          fill: true,
          theme: theme
        }, this.state.photos)));
      }
    }
  }]);

  return Photos;
}(_react["default"].Component);

var _default = Photos;
exports["default"] = _default;

//# sourceMappingURL=Photos.js.map